import React from "react";
import { useTranslation } from "react-i18next";

export const CommentGridHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="tbl-head-adjusted">
      <table className="tbl-basic tbl-data">
        <thead>
          <tr>
            {/* 機器分類 */}
            <th className="min-w-[110px] max-w-[110px]">{t("machines_category")}</th>
            {/* 件名 */}
            <th className="min-w-[100px] max-w-[100px]">{t("title")}</th>
            {/* 作業名 */}
            <th className="min-w-[80px] max-w-[80px]">{t("process_title")}</th>
            {/* 明細 */}
            <th className="min-w-[80px] max-w-[80px]">{t("detail")}</th>
            {/* コメント数 */}
            <th className="min-w-[80px] max-w-[80px]">{t("comment_number")}</th>
            {/* コメント */}
            <th className="w-full">{t("comment")}</th>
            {/* 登録日時 */}
            <th className="min-w-[160px] max-w-[160px]">{t("created_at")}</th>
            {/* 登録者 */}
            <th className="min-w-[100px] max-w-[100px]">{t("created_by")}</th>
            {/* 編集 */}
            <th className="min-w-[80px] max-w-[80px]">{t("edit")}</th>
            {/* 削除 */}
            <th className="min-w-[80px] max-w-[80px]">{t("delete")}</th>
          </tr>
        </thead>
      </table>
    </div>
  );
};
